module.exports = __webpack_public_path__ + "static/media/success.6c437a72.svg";